// extracted by css-extract-rspack-plugin
export default {"transactionRow":"rP1KANR_","alignRight":"NpThwGGx","transactionRight":"POJpEPnY","commonRowTransaction":"HCNWL0gp","disabled":"M7sCK3IF","transactionContent":"gfC5XB3s"};